import { useAtomValue } from "jotai";
import type { Section } from "../types";
import { questionnaireSectionsAtom } from "../state/questionnaireSectionsAtom";

/**
 * Get all sections. Re-renders on ANY section change - prefer useCurrentSection() when possible.
 *
 * @example const sections = useSections();
 * @see useCurrentSection - current section only (better performance)
 */
export function useSections(): Section[] {
  return useAtomValue(questionnaireSectionsAtom);
}
